export const toFixed = (num: number | string, fixed = 2) => {
  const numConverted = Number(num)
  return isNaN(numConverted) ? num : numConverted.toFixed(fixed);
}
